import { Scales } from "@phosphor-icons/react";
import { InfoHint } from "./InfoHint";

const rows = [
  { key: "low", label: "Лёгкие зоны (Z1–Z2)", color: "#00e676", target: "~80%" },
  { key: "mid", label: "«Серая зона» (Z3)", color: "#ffea00", target: "минимум" },
  { key: "high", label: "Интенсив (Z4–Z5)", color: "#ff3b30", target: "~20%" },
];

export default function PolarityCard({ polarity }) {
  if (!polarity) return null;
  return (
    <div className="glass-card p-5" data-testid="polarity-card">
      <div className="flex items-center gap-2 mb-1">
        <Scales size={18} weight="fill" className="text-[#0084ff]" />
        <h3 className="text-sm font-semibold">Полярность тренировок · правило 80/20<InfoHint text="Правило 80/20: примерно 80% тренировок должны быть лёгкими (низкая интенсивность) и лишь 20% — тяжёлыми. Карточка сравнивает ваше фактическое распределение с этим идеалом." /></h3>
      </div>
      <p className="text-xs text-muted-foreground mb-4">
        Распределение времени по зонам пульса за {polarity.workouts_n} тренировок. {polarity.verdict}
      </p>
      <div className="space-y-3">
        {rows.map((r) => (
          <div key={r.key} data-testid={`polarity-${r.key}`}>
            <div className="flex justify-between text-xs mb-1">
              <span style={{ color: r.color }} className="font-semibold">{r.label}</span>
              <span className="num"><span className="font-bold">{polarity[r.key]}%</span> <span className="text-muted-foreground">· цель {r.target}</span></span>
            </div>
            <div className="h-2.5 rounded-full bg-secondary overflow-hidden">
              <div className="h-full rounded-full" style={{ width: `${polarity[r.key]}%`, background: r.color }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
